import React, { Component } from 'react';
import { array, bool, func, number, object, string } from 'prop-types';
import { connect } from 'react-redux';
import { contains } from 'ramda';

import { DEFAULT_ATTACHMENT_URL } from '../../constants/AppConstants';
import { getAttachment } from '../../actions/attachments/attachmentsActions';

import Attachment from '../Attachment';

import cx from 'classnames';
import s from './AttachmentsList.css';


class AttachmentsList extends Component {
    static propTypes = {
        loadedId: number,
        loadedUrl: string,
        error: object,
        getAttachment: func,
        attachments: array,
        fromPatient: bool,
    };

    /**
     * downloadedAttachments is the array of all successfully downloaded attachments as {id, url}
     */
    constructor(props) {
        super(props);
        this.state = {
            downloadedAttachments: [],
        }
    }

    /**
     * When we get a new downloaded {id, url} add it to the list of downloadedAttachments
     */
    componentDidUpdate() {
        const {loadedId, loadedUrl, error} = this.props;

        if (loadedId === 0 || (loadedUrl === '/' && !error)) return;

        const attachment = {
            id: loadedId,
            url: loadedUrl,
            error: error
        };
        if (!contains(attachment, this.state.downloadedAttachments)) {
            this.setState({
                downloadedAttachments: [...this.state.downloadedAttachments, attachment]
            });
        }
    }

    /**
     * Build attachment download from MessagesList props.
     */
    renderAttachmentDownload = () => {
        const {
            getAttachment,
            attachments,
            fromPatient,
        } = this.props;

        const { downloadedAttachments } = this.state;

        return attachments.map((a, i) => {
            const id = a.id;
            const filename = a.name;
            const mimeType = a.mimeType;

            const downloadedAttachment = downloadedAttachments.find(function(entry) {
               return entry.id === id;
            });

            let url = DEFAULT_ATTACHMENT_URL;
            let attachmentError = undefined;
            if (!!downloadedAttachment) {
                url = downloadedAttachment.url;
                attachmentError = downloadedAttachment.error;
            }

            return (
                <div
                    key={i}
                    className={cx(s.component, fromPatient ? s.fromPatient : '')}
                >
                    <Attachment
                        id={id}
                        url={url}
                        error={attachmentError}
                        filename={filename}
                        mimeType={mimeType}
                        getAttachment={getAttachment}
                    />
                </div>
            );
        })
    };

    render() {
        const { attachments } = this.props;
        const attachmentDownloads = attachments && attachments.length >= 1;
        if (!attachmentDownloads) {
            return null;
        }
        else {
            return this.renderAttachmentDownload();
        }
    }
}

const mapStateToProps = state => ({
    loadedId: state.attachment.id,
    loadedUrl: state.attachment.url,
    error: state.attachment.error,
});

const mapDispatchToProps = dispatch => ({
    getAttachment: request => dispatch(getAttachment(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsList);
